/**
 * Canonical lifecycle status of an external-system connection (Bexio, D365 BC,
 * future Abacus, ...). Single shared vocabulary across all integration FE libs so
 * UI that shows multiple vendors side by side never has to translate status values.
 *
 * This is the PERSISTED lifecycle only. Transient UI states (idle / loading while a
 * request is in flight) are NOT part of this enum — track those as separate loading
 * flags, not as a connection status.
 */
export enum ConnectionStatus {
    CONNECTED = 'CONNECTED',
    EXPIRED = 'EXPIRED',
    ERROR = 'ERROR',
    DISCONNECTED = 'DISCONNECTED',
}
